import CollectionBannerCarousel from '@/modules/collection-banner';
import TextOverflow from '@/modules/text-overflow';
import BreadcrumbTop from '@/modules/collection-banner/breadcrumb-top';

const collectionBannerCarousel = document.querySelector('.js-collection-banner-carousel');
if (collectionBannerCarousel) {
    new CollectionBannerCarousel(collectionBannerCarousel)
}

const textOverflowElements = [...document.querySelectorAll('.js-text-overflow')];
if (textOverflowElements.length) {
    textOverflowElements.forEach(element => new TextOverflow(element));
}

new BreadcrumbTop();
